import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import TeaserActMasked from "../../../../teaser-base/act/teaser-act-masked";

const ActsCarouselSimple = ({ nodes }) => {
  const isMobile = useSelector((state) => state.appStore.isMobile);

  const sliderSettings = {
    adaptiveHeight: false,
    arrows: true,
    fade: false,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    touchMove: true,
    centerMode: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 786,
        settings: {
          slidesToShow: 2,
          touchMove: true,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1.5,
          touchMove: true,
        },
      },
    ],
  };

  return (
    <div
      className="carousel-wrapper acts-carousel-simple container no-padding"
    >
      <Slider {...sliderSettings}>
        {nodes.map((item, index) => {
          if (!item) {
            return null;
          }

          return (
            <React.Fragment key={index}>
              <TeaserActMasked
                item={item}
                index={index}
                forceMask={index - 1}
              />
            </React.Fragment>
          );
        })}
      </Slider>
    </div>
  );
};

ActsCarouselSimple.propTypes = {
  nodes: PropTypes.object.isRequired,
};

export default ActsCarouselSimple;
